/**
 *
 * @param {{query data object}} data
 * example:
 * --data--     { param1: val1, param2, val2 }
 * --return--  "param1=val1&param2=val2"
 */
const encodeQueryData = data => {
    return Object.keys(data)
        .map(key => [key, data[key]].join("="))
        .join("&");
};

const getQueryParams = windowLocationSearch => {
    return new URLSearchParams(windowLocationSearch);
};

export { encodeQueryData, getQueryParams };
